import React from "react"
import {IconButton, Menu, MenuItem} from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"

import {RevokeOfferModal} from "./RevokeOfferModal"

type OfferActionsMenuProps = {
	customerID: string
	offerID: string
	onRevokeSuccess: () => void
}

function OfferActionsMenu({customerID, offerID, onRevokeSuccess}: OfferActionsMenuProps) {
	const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null)
	const [revokeModalOpen, setRevokeModalOpen] = React.useState(false)

	const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation()
		setMenuAnchorEl(event.currentTarget)
	}

	const handleMenuClose = () => {
		setMenuAnchorEl(null)
	}

	const handleRevokeClick = () => {
		handleMenuClose()
		setRevokeModalOpen(true)
	}

	const handleRevokeSuccess = () => {
		setRevokeModalOpen(false)
		onRevokeSuccess()
	}

	const handleRevokeClose = () => {
		setRevokeModalOpen(false)
	}

	return (
		<>
			<IconButton size="small" onClick={handleMenuOpen}>
				<MoreVertIcon fontSize="small" />
			</IconButton>
			<Menu anchorEl={menuAnchorEl} open={Boolean(menuAnchorEl)} onClose={handleMenuClose}>
				<MenuItem onClick={handleRevokeClick}>Revoke</MenuItem>
			</Menu>
			<RevokeOfferModal
				customerID={customerID}
				offerID={offerID}
				open={revokeModalOpen}
				onClose={handleRevokeClose}
				onSuccess={handleRevokeSuccess}
			/>
		</>
	)
}

export {OfferActionsMenu}
